import { useEffect, useState } from 'react'
import axios from 'services/axios'
import { useParams } from 'react-router-dom'
import { CurrentZone } from 'utils/types'
import { useSelector } from 'react-redux'
import { selectCurrentZone } from 'store/global'

export interface AggregateFlowEntry {
  name: string
  inflows: number
  outflows: number
  depositCount: number
  withdrawalCount: number
  totalActivities: number
  firstActivity: string | null
  lastActivity: string | null
}

const useAggregateFlows = () => {
  const { entityId } = useParams<{ entityId: string }>()
  const currentZone: CurrentZone = useSelector(selectCurrentZone)

  const [data, setData] = useState<AggregateFlowEntry[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (!entityId || !currentZone?.cryptoActivityIndices) return

    setIsLoading(true)
    axios
      .get(`crypto/aggregate-flows/${entityId}`, {
        params: { zone: currentZone.cryptoActivityIndices },
      })
      .then(res => setData(res.data?.exchanges ?? []))
      .catch(err => console.error(err))
      .finally(() => setIsLoading(false))
  }, [entityId, currentZone?.cryptoActivityIndices])

  return { data, isLoading }
}

export default useAggregateFlows
